
const ICONS = {
  arrowRight: (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.707 11.9908L22.364 17.6478C22.5515 17.8354 22.6568 18.0897 22.6568 18.3548C22.6568 18.62 22.5515 18.8743 22.364 19.0618L16.707 24.7188C16.5184 24.901 16.2658 25.0018 16.0036 24.9995C15.7414 24.9972 15.4906 24.8921 15.3052 24.7067C15.1198 24.5212 15.0146 24.2704 15.0123 24.0082C15.01 23.746 15.1108 23.4934 15.293 23.3048L19.243 19.3548L6 19.3548C5.73478 19.3548 5.48043 19.2495 5.29289 19.0619C5.10536 18.8744 5 18.6201 5 18.3548C5 18.0896 5.10536 17.8353 5.29289 17.6477C5.48043 17.4602 5.73478 17.3548 6 17.3548L19.243 17.3548L15.293 13.4048C15.1975 13.3126 15.1213 13.2022 15.0689 13.0802C15.0165 12.9582 14.9889 12.827 14.9877 12.6942C14.9866 12.5615 15.0119 12.4298 15.0622 12.3069C15.1125 12.184 15.1867 12.0723 15.2806 11.9784C15.3745 11.8845 15.4861 11.8103 15.609 11.76C15.7319 11.7097 15.8636 11.6844 15.9964 11.6856C16.1292 11.6867 16.2604 11.7143 16.3824 11.7667C16.5044 11.8191 16.6148 11.8953 16.707 11.9908Z" />
    </svg>
  ),
  arrowLeft: (
    <svg
      width="27"
      height="37"
      viewBox="0 0 27 37"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3719_6079"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="5"
        y="12"
        width="18"
        height="14"
      >
        <path
          d="M5.29279 18.1486C5.10532 18.3362 5 18.5905 5 18.8556C5 19.1208 5.10532 19.3751 5.29279 19.5626L10.9498 25.2196C11.1384 25.4018 11.391 25.5026 11.6532 25.5003C11.9154 25.498 12.1662 25.3929 12.3516 25.2075C12.537 25.0221 12.6422 24.7712 12.6445 24.509C12.6467 24.2469 12.5459 23.9943 12.3638 23.8056L8.41379 19.8556L21.6568 19.8556C21.922 19.8556 22.1764 19.7503 22.3639 19.5628C22.5514 19.3752 22.6568 19.1209 22.6568 18.8556C22.6568 18.5904 22.5514 18.3361 22.3639 18.1485C22.1764 17.961 21.922 17.8556 21.6568 17.8556L8.41379 17.8556L12.3638 13.9056C12.5459 13.717 12.6467 13.4644 12.6445 13.2022C12.6422 12.9401 12.537 12.6892 12.3516 12.5038C12.1662 12.3184 11.9154 12.2133 11.6532 12.211C11.391 12.2087 11.1384 12.3095 10.9498 12.4916L5.29279 18.1486Z"
          fill="black"
        />
      </mask>
      <g mask="url(#mask0_3719_6079)">
        <rect
          width="27"
          height="36"
          transform="matrix(1 0 0 -1 0 36.5)"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  person: (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.9961 12.0677C17.9961 14.3143 16.2052 16.1355 13.9961 16.1355C11.787 16.1355 9.99609 14.3143 9.99609 12.0677C9.99609 9.82118 11.787 8 13.9961 8C16.2052 8 17.9961 9.82118 17.9961 12.0677Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M17.4091 19.8645H10.5909C7.45288 19.8645 4.64207 22.828 6.70731 25.2443C8.11176 26.8875 10.4343 28 14 28C17.5657 28 19.8882 26.8875 21.2927 25.2443C23.3579 22.828 20.5471 19.8645 17.4091 19.8645Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  crossbtn: (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_3719_35129"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="1"
        y="5"
        width="26"
        height="26"
      >
        <path
          d="M14 5C6.811 5 1 10.811 1 18C1 25.189 6.811 31 14 31C21.189 31 27 25.189 27 18C27 10.811 21.189 5 14 5ZM14 28.4C8.267 28.4 3.6 23.733 3.6 18C3.6 12.267 8.267 7.6 14 7.6C19.733 7.6 24.4 12.267 24.4 18C24.4 23.733 19.733 28.4 14 28.4ZM18.667 11.5L14 16.167L9.333 11.5L7.5 13.333L12.167 18L7.5 22.667L9.333 24.5L14 19.833L18.667 24.5L20.5 22.667L15.833 18L20.5 13.333L18.667 11.5Z"
          fill="#BF3636"
        />
      </mask>
      <g mask="url(#mask0_3719_35129)">
        <rect
          x="-3.11523"
          y="-6.92383"
          width="33.2308"
          height="49.8462"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  checkMark: (
    <svg
      width="27"
      height="37"
      viewBox="0 0 27 37"
      fill="currentColor"

      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3719_7174)">
        <mask
          id="mask0_3719_7174"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="6"
          width="27"
          height="24"
        >
          <path
            d="M8.86205 29.5L0 20.3089L4.03858 16.1203L8.86205 21.1377L22.9614 6.5L27 10.6885L8.86205 29.5Z"
            fill="currentColor"
          />
        </mask>
        <g mask="url(#mask0_3719_7174)">
          <rect
            width="27"
            height="36"
            transform="matrix(-1 0 0 1 27 0.5)"
            fill="currentColor"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_3719_7174">
          <rect
            width="27"
            height="36"
            fill="currentColor"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  settings: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.1214 5.45482C20.9498 4.28325 19.0503 4.28324 17.8787 5.45482L15.8787 7.45482C15.3161 8.01742 14.553 8.3335 13.7574 8.3335H11.3334C9.67652 8.3335 8.33337 9.67664 8.33337 11.3335V13.7575C8.33337 14.5532 8.0173 15.3162 7.45469 15.8788L5.4547 17.8788C4.28312 19.0504 4.28312 20.9499 5.45469 22.1215L7.45469 24.1215C8.0173 24.6841 8.33337 25.4472 8.33337 26.2428V28.6668C8.33337 30.3237 9.67652 31.6668 11.3334 31.6668H13.7574C14.5531 31.6668 15.3161 31.9829 15.8787 32.5455L17.8787 34.5455C19.0503 35.7171 20.9498 35.7171 22.1214 34.5455L24.1214 32.5455C24.684 31.9829 25.447 31.6668 26.2427 31.6668H28.6667C30.3236 31.6668 31.6667 30.3237 31.6667 28.6668V26.2428C31.6667 25.4472 31.9828 24.6841 32.5454 24.1215L34.5454 22.1215C35.717 20.9499 35.717 19.0504 34.5454 17.8788L32.5454 15.8788C31.9828 15.3162 31.6667 14.5532 31.6667 13.7575V11.3335C31.6667 9.67664 30.3236 8.3335 28.6667 8.3335H26.2427C25.447 8.3335 24.684 8.01743 24.1214 7.45482L22.1214 5.45482Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M20 25C21.3261 25 22.5979 24.4732 23.5355 23.5355C24.4732 22.5979 25 21.3261 25 20C25 18.6739 24.4732 17.4021 23.5355 16.4645C22.5979 15.5268 21.3261 15 20 15C18.6739 15 17.4021 15.5268 16.4645 16.4645C15.5268 17.4021 15 18.6739 15 20C15 21.3261 15.5268 22.5979 16.4645 23.5355C17.4021 24.4732 18.6739 25 20 25Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  ),
  logout: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.1416 14.9998H13.7883M22.5166 21.0598L28.3333 14.9998L22.5166 8.93984M17.425 6.6665V1.6665H1.66663V28.3332H17.425V23.3332"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  cart: (
<svg
  width="30"
  height="34"
  viewBox="0 0 30 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M9.3999 30.3332C8.66657 30.3332 8.03901 30.0723 7.51724 29.5505C6.99546 29.0287 6.73412 28.4007 6.73324 27.6665C6.73324 26.9332 6.99457 26.3056 7.51724 25.7838C8.0399 25.2621 8.66746 25.0007 9.3999 24.9998C10.1332 24.9998 10.7612 25.2612 11.2839 25.7838C11.8066 26.3065 12.0675 26.9341 12.0666 27.6665C12.0666 28.3998 11.8057 29.0278 11.2839 29.5505C10.7621 30.0732 10.1341 30.3341 9.3999 30.3332ZM22.7332 30.3332C21.9999 30.3332 21.3723 30.0723 20.8506 29.5505C20.3288 29.0287 20.0675 28.4007 20.0666 27.6665C20.0666 26.9332 20.3279 26.3056 20.8506 25.7838C21.3732 25.2621 22.0008 25.0007 22.7332 24.9998C23.4666 24.9998 24.0946 25.2612 24.6172 25.7838C25.1399 26.3065 25.4008 26.9341 25.3999 27.6665C25.3999 28.3998 25.139 29.0278 24.6172 29.5505C24.0955 30.0732 23.4675 30.3341 22.7332 30.3332ZM8.26657 8.99984L11.4666 15.6665H20.7999L24.4666 8.99984H8.26657ZM6.9999 6.33317H28.9999L22.3666 18.3332H10.8666L9.3999 20.9998H25.3999V23.6665H4.8999L8.86657 16.4665L4.06657 6.33317H1.3999V3.6665H5.73324L6.9999 6.33317Z"
    fill="currentColor" // Set to currentColor to inherit the color from parent
  />
</svg>
  ),

  download: (
    <svg
    width="27"
    height="36"
    viewBox="0 0 27 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_415_4203"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="2"
      y="7"
      width="22"
      height="22"
    >
      <path
        d="M13 23.621L7.44029 18.0597L8.55129 16.9299L12.2143 20.5929L12.2143 7H13.7857L13.7857 20.5929L17.4471 16.9314L18.5597 18.0597L13 23.621ZM4.53786 29C3.815 29 3.21157 28.758 2.72757 28.274C2.24252 27.789 2 27.185 2 26.4621L2 22.6546H3.57143V26.4621C3.57143 26.7031 3.672 26.9247 3.87314 27.1269C4.07533 27.328 4.2969 27.4286 4.53786 27.4286L21.4621 27.4286C21.7031 27.4286 21.9247 27.328 22.1269 27.1269C22.328 26.9247 22.4286 26.7031 22.4286 26.4621V22.6546H24V26.4621C24 27.185 23.758 27.7884 23.274 28.2724C22.789 28.7575 22.185 29 21.4621 29L4.53786 29Z"
        fill="currentColor" 
      />
    </mask>
    <g mask="url(#mask0_415_4203)">
      <rect
        width="27"
        height="36"
        transform="matrix(-1 0 0 1 27 0)"
        fill="currentColor" 
      />
    </g>
  </svg>
  ),

  submit: (
    <svg
      width="27"
      height="36"
      viewBox="0 0 27 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_305_11199"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="27"
        height="32"
      >
        <path
          d="M14.9999 12V3L5.99987 3C5.20422 3 4.44116 3.31607 3.87855 3.87868C3.31594 4.44129 2.99987 5.20435 2.99987 6L2.99987 17.4C4.54629 16.6101 6.30252 16.3284 8.01842 16.5948C9.73432 16.8612 11.3224 17.6623 12.5565 18.8839C13.7906 20.1056 14.6077 21.6854 14.8916 23.3985C15.1754 25.1116 14.9115 26.8706 14.1374 28.425L17.2304 31.5195C17.6474 31.935 17.8949 32.4585 17.9729 33H23.9999C24.7955 33 25.5586 32.6839 26.1212 32.1213C26.6838 31.5587 26.9999 30.7956 26.9999 30V15H17.9999C17.2042 15 16.4412 14.6839 15.8785 14.1213C15.3159 13.5587 14.9999 12.7956 14.9999 12ZM17.2499 12V3.75L26.2499 12.75H17.9999C17.801 12.75 17.6102 12.671 17.4695 12.5303C17.3289 12.3897 17.2499 12.1989 17.2499 12ZM6.74987 31.5C8.15163 31.502 9.51894 31.0657 10.6604 30.252L14.5799 34.17C14.6829 34.2805 14.8071 34.3692 14.9451 34.4307C15.0831 34.4922 15.232 34.5252 15.3831 34.5279C15.5341 34.5306 15.6842 34.5028 15.8243 34.4462C15.9643 34.3896 16.0916 34.3054 16.1984 34.1986C16.3053 34.0917 16.3895 33.9645 16.4461 33.8244C16.5026 33.6843 16.5304 33.5343 16.5278 33.3832C16.5251 33.2322 16.492 33.0832 16.4305 32.9452C16.3691 32.8072 16.2804 32.683 16.1699 32.58L12.2519 28.6605C13.1285 27.4271 13.5653 25.935 13.4921 24.4236C13.4189 22.9122 12.8401 21.4692 11.8484 20.3263C10.8567 19.1834 9.5098 18.4068 8.02382 18.1213C6.53785 17.8357 4.99902 18.0577 3.65437 18.7517C2.30972 19.4457 1.23724 20.5713 0.609091 21.9479C-0.0190579 23.3245 -0.166439 24.8723 0.190606 26.3427C0.547651 27.8132 1.38841 29.121 2.57793 30.0562C3.76744 30.9915 5.23671 31.5 6.74987 31.5ZM6.74987 29.25C5.55639 29.25 4.4118 28.7759 3.56789 27.932C2.72397 27.0881 2.24987 25.9435 2.24987 24.75C2.24987 23.5565 2.72397 22.4119 3.56789 21.568C4.4118 20.7241 5.55639 20.25 6.74987 20.25C7.94334 20.25 9.08793 20.7241 9.93185 21.568C10.7758 22.4119 11.2499 23.5565 11.2499 24.75C11.2499 25.9435 10.7758 27.0881 9.93185 27.932C9.08793 28.7759 7.94334 29.25 6.74987 29.25Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_305_11199)">
        <rect width="27" height="36" fill="white" />
      </g>
    </svg>
  ),

  delete:(
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.666 8.74992V9.16658H23.3327V8.74992C23.3327 7.86586 22.9815 7.01802 22.3564 6.3929C21.7312 5.76777 20.8834 5.41659 19.9993 5.41659C19.1153 5.41659 18.2674 5.76777 17.6423 6.3929C17.0172 7.01802 16.666 7.86586 16.666 8.74992ZM14.5827 9.16658V8.74992C14.5827 7.31333 15.1534 5.93558 16.1692 4.91976C17.185 3.90393 18.5628 3.33325 19.9993 3.33325C21.4359 3.33325 22.8137 3.90393 23.8295 4.91976C24.8453 5.93558 25.416 7.31333 25.416 8.74992V9.16658H34.791C35.0673 9.16658 35.3322 9.27633 35.5276 9.47168C35.7229 9.66703 35.8327 9.93198 35.8327 10.2083C35.8327 10.4845 35.7229 10.7495 35.5276 10.9448C35.3322 11.1402 35.0673 11.2499 34.791 11.2499H32.3602L30.6935 31.1299C30.5669 32.6396 29.8777 34.0466 28.7625 35.0721C27.6474 36.0976 26.1877 36.6667 24.6727 36.6666H15.326C13.8112 36.6665 12.3517 36.0973 11.2367 35.0718C10.1217 34.0463 9.43264 32.6395 9.30602 31.1299L7.63935 11.2499H5.20768C4.93142 11.2499 4.66646 11.1402 4.47111 10.9448C4.27576 10.7495 4.16602 10.4845 4.16602 10.2083C4.16602 9.93198 4.27576 9.66703 4.47111 9.47168C4.66646 9.27633 4.93142 9.16658 5.20768 9.16658H14.5827ZM11.3818 30.9558C11.4648 31.9448 11.9163 32.8665 12.6468 33.5384C13.3773 34.2103 14.3335 34.5832 15.326 34.5833H24.6727C25.6653 34.5834 26.6218 34.2106 27.3525 33.5387C28.0831 32.8668 28.5347 31.9449 28.6177 30.9558L30.2694 11.2499H9.72935L11.3818 30.9558ZM17.916 16.8749C17.916 16.7381 17.8891 16.6027 17.8367 16.4763C17.7844 16.3499 17.7076 16.2351 17.6109 16.1383C17.5142 16.0416 17.3994 15.9649 17.273 15.9125C17.1466 15.8602 17.0111 15.8333 16.8743 15.8333C16.7376 15.8333 16.6021 15.8602 16.4757 15.9125C16.3493 15.9649 16.2345 16.0416 16.1378 16.1383C16.0411 16.2351 15.9643 16.3499 15.912 16.4763C15.8596 16.6027 15.8327 16.7381 15.8327 16.8749V28.9583C15.8327 29.095 15.8596 29.2305 15.912 29.3569C15.9643 29.4833 16.0411 29.5981 16.1378 29.6948C16.2345 29.7915 16.3493 29.8683 16.4757 29.9206C16.6021 29.973 16.7376 29.9999 16.8743 29.9999C17.0111 29.9999 17.1466 29.973 17.273 29.9206C17.3994 29.8683 17.5142 29.7915 17.6109 29.6948C17.7076 29.5981 17.7844 29.4833 17.8367 29.3569C17.8891 29.2305 17.916 29.095 17.916 28.9583V16.8749ZM23.1243 15.8333C23.6993 15.8333 24.166 16.2999 24.166 16.8749V28.9583C24.166 29.2345 24.0563 29.4995 23.8609 29.6948C23.6656 29.8902 23.4006 29.9999 23.1243 29.9999C22.8481 29.9999 22.5831 29.8902 22.3878 29.6948C22.1924 29.4995 22.0827 29.2345 22.0827 28.9583V16.8749C22.0827 16.2999 22.5493 15.8333 23.1243 15.8333Z" fill="#BF3636"/>
</svg>

  ),

  headerMenu: (
    <svg width="38" height="32" viewBox="0 0 38 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1H37" stroke="white" strokeWidth="2" strokeLinecap="round"/>
<path d="M19 16H37" stroke="white" strokeWidth="2" strokeLinecap="round"/>
<path d="M1 31H37" stroke="white" strokeWidth="2" strokeLinecap="round"/>
</svg>

  ),

  home: (
    <svg width="27" height="36" viewBox="0 0 27 36" fill="none" xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_3920_8465" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="1" y="6" width="24" height="24">
<path d="M6 18H4L13 9L22 18H20M6 18L6 25C6 25.5304 6.21071 26.0391 6.58579 26.4142C6.96086 26.7893 7.46957 27 8 27L18 27C18.5304 27 19.0391 26.7893 19.4142 26.4142C19.7893 26.0391 20 25.5304 20 25V18" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10 27L10 21C10 20.4696 10.2107 19.9609 10.5858 19.5858C10.9609 19.2107 11.4696 19 12 19H14C14.5304 19 15.0391 19.2107 15.4142 19.5858C15.7893 19.9609 16 20.4696 16 21L16 27" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</mask>
<g mask="url(#mask0_3920_8465)">
<rect width="27" height="36" transform="matrix(-1 0 0 1 27 0)" fill="white"/>
</g>
</svg>

  )
};

const Button = ({
  iconType = null,
  label,
  labelPosition = "left",
  onClick = () => {},
  variant = "blue",
  color = "blue",
  ...props
}) => {
  const icon = ICONS[iconType] || null;

  const buttonClass = `custom-button ${
    variant === "transparent"
      ? `button-transparent button-transparent-${color}`
      : `button-${variant}`
  } ${labelPosition === "none" ? "no-label" : ""} ${
    labelPosition === "center" ? "button-center" : ""
  }`;

  const renderLabel = label && labelPosition !== "none";
  const renderIcon = icon;

  return (
    <button
      type={props.type || "button"}
      className={buttonClass}
      onClick={onClick}
      {...props}
    >
      {labelPosition === "left" && renderLabel && (
        <span className="button-label">{label}</span>
      )}
      {renderIcon && icon}
      {labelPosition === "right" && renderLabel && (
        <span className="button-label">{label}</span>
      )}
      {labelPosition === "center" && renderLabel && (
        <span className="button-label">{label}</span>
      )}
    </button>
  );
};

export default Button;
